import React, { useEffect, useRef } from "react"
import mapboxgl from "mapbox-gl"

import "mapbox-gl/dist/mapbox-gl.css"
import { Link } from "eddev/routing"

export const Mapbox = ({ long, lat, link }: { long: number; lat: number; link?: string }) => {
  const mapContainerRef = useRef<HTMLDivElement>(null)
  const mapRef = useRef<mapboxgl.Map | null>(null)

  useEffect(() => {
    if (!mapContainerRef.current) return

    mapboxgl.accessToken =
      "pk.eyJ1IjoiZGFuaWVsLWVkIiwiYSI6ImNtN29kMjVjbzBhMWEycm9scHFxZnl0ODUifQ.7rFJD2Qj86bZJqhVc0fTUg"

    mapRef.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      center: [long, lat], // starting position [lng, lat]
      zoom: 14, // starting zoom
      style: "mapbox://styles/daniel-ed/cl9w6kh2r000315mtet0z51an",
      attributionControl: false,
    })

    new mapboxgl.Marker().setLngLat([long, lat]).addTo(mapRef.current)
  })

  const Wrap = link ? Link : "div"
  const wrapProps = link ? { href: link, target: "_blank" } : {}

  return (
    <Wrap {...wrapProps} className="w-full">
      <div ref={mapContainerRef} className="map-container aspect-[16/8] pointer-events-none" />
    </Wrap>
  )
}
